var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown-menu",
    {
      class: [
        "c-template_dropdown_menu",
        _vm.$attrs.className !== undefined ? _vm.$attrs.className : "",
      ],
    },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "el-dropdown-item",
        {
          key: index,
          class: [
            "c-template_dropdown_menu__item",
            item.code == "del" ? "is-del" : "",
          ],
          attrs: {
            disabled: item.disabled != undefined ? item.disabled : false,
            divided: item.divided != undefined ? item.divided : false,
          },
          nativeOn: {
            click: function ($event) {
              return (() => {
                _vm.$emit("on-click", { item, index })
              }).apply(null, arguments)
            },
          },
        },
        [
          item.custom
            ? _c("div", [_vm._t("custom", null, { data: item })], 2)
            : _c("div", { staticClass: "value" }, [
                item.icon ? _c("i", { class: [item.icon, "icon"] }) : _vm._e(),
                _vm._v(" " + _vm._s(item.value) + " "),
              ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }